import { StarFilled, StarOutlined } from '@ant-design/icons';
import type { ComponentPropsWithRef } from 'react';
import styled from 'styled-components';

import IconButton from '@/components/Button/IconButton';
import type { IconButtonT } from '@/components/Button/IconButton/types';
import useColor from '@/hooks/domain/useColor';

type Props = {
  value: boolean;
  onChange?: (value: boolean) => void;
  size?: number;
  className?: string;
  readonly?: boolean;
  tooltip?: React.ReactNode;
  style?: React.CSSProperties;
  outlined?: boolean;
};

const FavoriteToggle = (props: Props) => {
  const size = props.size || 14;
  const color = useColor();
  return (
    <Style
      className={props.className}
      tooltip={props.tooltip}
      onClick={(e) => {
        if (props.readonly) return;
        e.stopPropagation();
        props.onChange?.(!props.value);
      }}
      outlined={props.outlined || false}
      readonly={props.readonly}
      sizeType="m"
      style={props.style}
      icon={
        props.value ? (
          <StarFilled style={{ fontSize: size, color: color.yellow500 }} />
        ) : (
          <StarOutlined className="star-outlined" style={{ fontSize: size }} />
        )
      }
    />
  );
};

type StyleProps = IconButtonT &
  ComponentPropsWithRef<'button'> & {
    readonly?: boolean;
  };

const Style = styled(IconButton)<StyleProps>`
  .star-outlined {
    color: ${(props) => props.theme.colors.gray400};
    transition: all 0.2s;
  }
  &:hover {
    background-color: ${(props) =>
      props.readonly ? 'unset' : props.theme.colors.ND04};
    .star-outlined {
      color: ${(props) =>
        props.readonly
          ? props.theme.colors.gray400
          : props.theme.colors.gray700};
    }
  }
`;

export default FavoriteToggle;
